import type { GetStyles, LayoutStyledProps } from '@sds-system/types';

export const getLayoutStyles: GetStyles<LayoutStyledProps> = ({
  p,
  pb,
  pl,
  pr,
  pt,
  px,
  py,
  m,
  mb,
  ml,
  mr,
  mt,
  mx,
  my,
  top,
  left,
  right,
  bottom,
  position: positionValue,
  gap: spacingValue,
  theme,
}) => {
  return {
    ...((m || m === 0) && {
      margin: theme.space[m],
    }),
    ...((mx || mx === 0) && {
      marginLeft: theme.space[mx],
      marginRight: theme.space[mx],
    }),
    ...((my || my === 0) && {
      marginBottom: theme.space[my],
      marginTop: theme.space[my],
    }),
    ...((mt || mt === 0) && {
      marginTop: theme.space[mt],
    }),
    ...((mr || mr === 0) && {
      marginRight: theme.space[mr],
    }),
    ...((mb || mb === 0) && {
      marginBottom: theme.space[mb],
    }),
    ...((ml || ml === 0) && {
      marginLeft: theme.space[ml],
    }),
    ...((p || p === 0) && {
      padding: theme.space[p],
    }),
    ...((px || px === 0) && {
      paddingLeft: theme.space[px],
      paddingRight: theme.space[px],
    }),
    ...((py || py === 0) && {
      paddingBottom: theme.space[py],
      paddingTop: theme.space[py],
    }),
    ...((pt || pt === 0) && {
      paddingTop: theme.space[pt],
    }),
    ...((pr || pr === 0) && {
      paddingRight: theme.space[pr],
    }),
    ...((pb || pb === 0) && {
      paddingBottom: theme.space[pb],
    }),
    ...((pl || pl === 0) && {
      paddingLeft: theme.space[pl],
    }),
    position: positionValue,
    ...((top || top === 0) && {
      top: theme.space[top],
    }),
    ...((left || left === 0) && {
      left: theme.space[left],
    }),
    ...((right || right === 0) && {
      right: theme.space[right],
    }),
    ...((bottom || bottom === 0) && {
      bottom: theme.space[bottom],
    }),
    ...((spacingValue || spacingValue === 0) && {
      gap: theme.space[spacingValue],
    }),
  };
};
